import { Suspense } from "react";
import { lazyWithRetry } from "@circle-react/helpers/lazyRetry";
import { PageLoader } from "@circle-react/pages/PageLoader";

const LiveStreamsSettingsComponent = lazyWithRetry(
  () =>
    import(
      /* webpackChunkName: "LiveStreamsSettingsPage" */ "@circle-react/components/SettingsApp/LiveStreamSettings"
    ),
);

export const LiveStreamsSettingsPage = () => (
  <Suspense fallback={<PageLoader />}>
    <LiveStreamsSettingsComponent />
  </Suspense>
);
